import { Model } from '@/app/shared/models/model';
import {
  CampaignRules,
  CampaignModel,
  InstallmentCampaign,
} from '@/app/shared/models';
export class ResponseCampaignModel extends Model {
  public NotifyId!: string;
  public CampaignId!: string;
  public CampaignRulerId!: string;
  public ContractId!: string;
  public SettingCampaign!: CampaignModel;
  public SettingCampaignRuler!: CampaignRules;
  public Status!: number;
  public InstallmentCampaigns?: InstallmentCampaign[];
}
